import {
  ClosedAsQualifiedReasonsResponse,
  DisqualifiedReasonsResponse,
  LeadReason
} from "@/entities/settings/types";
import useAPI, { useAPIMutation } from "@/services/api/hook";
import { ExtendedUseQueryResult } from "@/services/api/types";
import { useQueryClient } from "@tanstack/react-query";

// Lead disqualified reasons

export const useDisqualifiedReasonsSettings = (
  options?: { enabled?: boolean }
): ExtendedUseQueryResult<DisqualifiedReasonsResponse> =>
  useAPI("settings/leads/disqualifiedReasons", undefined, {
    enabled: options?.enabled ?? true
  });

export const useCreateDisqualifiedReason = () => {
  const queryClient = useQueryClient();
  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: ["settings/leads/disqualifiedReasons"]
    });
  return useAPIMutation<{ data: { name: string } }, { id: number }>(
    "settings/leads/disqualifiedReasons/create",
    { method: "POST" },
    invalidate,
    invalidate
  );
};

export const useUpdateDisqualifiedReason = () => {
  const queryClient = useQueryClient();
  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: ["settings/leads/disqualifiedReasons"]
    });
  return useAPIMutation<
    { pathParams: { reasonId: string }; data: { name: string } },
    LeadReason
  >(
    "settings/leads/disqualifiedReasons/update",
    { method: "PUT" },
    invalidate,
    invalidate
  );
};

export const useDeleteDisqualifiedReason = () => {
  const queryClient = useQueryClient();
  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: ["settings/leads/disqualifiedReasons"]
    });
  return useAPIMutation<
    { pathParams: { reasonId: string }; data: Record<string, never> },
    void
  >(
    "settings/leads/disqualifiedReasons/delete",
    { method: "DELETE" },
    invalidate,
    invalidate
  );
};

export const useUpdateDisqualifiedReasonsOrder = () => {
  const queryClient = useQueryClient();
  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: ["settings/leads/disqualifiedReasons"]
    });
  return useAPIMutation<{ data: number[] }, void>(
    "settings/leads/disqualifiedReasons/order",
    { method: "PUT" },
    invalidate,
    invalidate
  );
};

// Lead closed-as-qualified reasons

export const useClosedAsQualifiedReasonsSettings = (
  options?: { enabled?: boolean }
): ExtendedUseQueryResult<ClosedAsQualifiedReasonsResponse> =>
  useAPI("settings/leads/closedAsQualifiedReasons", undefined, {
    enabled: options?.enabled ?? true
  });

export const useCreateClosedAsQualifiedReason = () => {
  const queryClient = useQueryClient();
  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: ["settings/leads/closedAsQualifiedReasons"]
    });
  return useAPIMutation<{ data: { name: string } }, { id: number }>(
    "settings/leads/closedAsQualifiedReasons/create",
    { method: "POST" },
    invalidate,
    invalidate
  );
};

export const useUpdateClosedAsQualifiedReason = () => {
  const queryClient = useQueryClient();
  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: ["settings/leads/closedAsQualifiedReasons"]
    });
  return useAPIMutation<
    { pathParams: { reasonId: string }; data: { name: string } },
    LeadReason
  >(
    "settings/leads/closedAsQualifiedReasons/update",
    { method: "PUT" },
    invalidate,
    invalidate
  );
};

export const useDeleteClosedAsQualifiedReason = () => {
  const queryClient = useQueryClient();
  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: ["settings/leads/closedAsQualifiedReasons"]
    });
  return useAPIMutation<
    { pathParams: { reasonId: string }; data: Record<string, never> },
    void
  >(
    "settings/leads/closedAsQualifiedReasons/delete",
    { method: "DELETE" },
    invalidate,
    invalidate
  );
};

export const useUpdateClosedAsQualifiedReasonsOrder = () => {
  const queryClient = useQueryClient();
  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: ["settings/leads/closedAsQualifiedReasons"]
    });
  return useAPIMutation<{ data: number[] }, void>(
    "settings/leads/closedAsQualifiedReasons/order",
    { method: "PUT" },
    invalidate,
    invalidate
  );
};
